<template>
  <div class="footer">
    <div class="container">
      <div class="contact-info">
        <p class="address">
          &copy; {{new Date().getFullYear()}}
          Brock University
          <span class="separator">/</span>
          Niagara Region
          <span class="separator">/</span>
          1812 Sir Isaac Brock Way
          <span class="separator">/</span>
          St. Catharines, ON, L2S 3A1 Canada
          <span class="separator">/</span>
          <a class="primary-phone-number" href="tel://+19056885550">+1 905-688-5550</a>

        </p>
        <img class="footer-logo" src="../assets/logo.svg" />
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'BrockFooter',
};
</script>

<style lang="scss" scoped>
  @import "../assets/_globals.scss";
  @import "../assets/_colors.scss";

  .container{
    max-width: $container-width;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 1rem;
    padding-right: 1rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .footer{
    background-color: $red;
    padding-top: 2rem;
    padding-bottom: 2rem;
    margin-top: 3rem;
    color: $white;
    @media screen and (max-width: $break-medium) {
      flex-direction: column;
      text-align: center;
    }
  }

  .contact-info{
    display: flex;
    flex-direction: row;
    align-items: center;

    .address{
      margin: 0;
      flex: 1;
      font-size: .9rem;
      .separator{
        color: rgba(255,255,255,.3);
      }
      a{
        color: white;
        text-decoration: none;
        &:hover{
          text-decoration: underline;
        }
      }
    }

    @media screen and (max-width: $break-medium) {
      flex-direction: column;
    }
  }

  .footer-logo{
    height: 4rem;
    width: auto;

    @media screen and (max-width: $break-medium) {
      margin-top: 2rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/BrockFooter.vue